import { AppImages, assignTextStyle, I18N, Settings, variantProvider } from '@/app'
import { View, Image, Button, Text } from '@/components'
import { MOBILE_BREAKPOINT, MID_BREAKPOINT, LARGE_BREAKPOINT } from '@/app'
import { AnalyticsEvents } from '@/services'

export function StoreButton({
  storeLink,
  image,
  variants = [],
  imageStyles = styles.storeImage,
  store,
}) {
  function openLink() {
    AnalyticsEvents.downloadClick(store)
    window.open(storeLink, '_blank')
  }

  return (
    <Button variants={variants} debugName='store-btn' onPress={openLink}>
      <Image source={image} css={imageStyles} />
    </Button>
  )
}

export function FooterStores() {
  return (
    <View css={styles.wrapper}>
      <Text css={styles.title} variants={['h0']} text={I18N.t('footer.hero')} />
      <View css={styles.innerWrapper}>
        <StoreButton
          variants={['store:footer']}
          image={AppImages.AppStore}
          storeLink={Settings.Stores.Apple.url}
          store={'app_store'}
        />
        <StoreButton
          variants={['store:footer']}
          image={AppImages.GooglePlay}
          storeLink={Settings.Stores.Google.url}
          store={'google_play'}
        />
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    ...theme.presets.column,
    ...theme.spacing.gap(5),

    [theme.media.down(LARGE_BREAKPOINT)]: {
      width: theme.spacing.value(44),
    },

    [theme.media.down(MID_BREAKPOINT)]: {
      width: theme.spacing.value(36),
    },

    [theme.media.down(MOBILE_BREAKPOINT)]: {
      ...theme.presets.fullWidth,
    },
  },

  title: {
    ...assignTextStyle('h0')(theme).text,
    color: theme.colors.neutral1,

    [theme.media.down(LARGE_BREAKPOINT)]: {
      ...assignTextStyle('h1')(theme).text,
      color: theme.colors.neutral1,
    },

    [theme.media.down(MOBILE_BREAKPOINT)]: {
      ...theme.presets.textCenter,
    },
  },

  innerWrapper: {
    ...theme.spacing.gap(2.5),

    [theme.media.down(MOBILE_BREAKPOINT)]: {
      ...theme.presets.center,
    },
  },

  storeImage: {
    height: theme.spacing.value(4),

    [theme.media.down('tablet')]: {
      height: theme.spacing.value(2.5),
    },

    [theme.media.down('mobile')]: {
      height: 'unset',
      width: '100%',
    },
  },
}), true)
